import React from "react";
import { fmtMoney } from './vencimientosConfig';

/* 4 KPIs clickeables como quick-filter. `active` = id seleccionado, onPick(id). */
export default function KpiCards({ kpis, active, onPick }) {
  const k = kpis || {};
  const vencidos = k.vencidos || { count: 0, monto_en_mora: 0 };
  const porVencer = k.por_vencer_30d || { count: 0, monto: 0 };

  const cards = [
    {
      id: 'vencidos',
      tone: 'danger',
      icon: 'pi-exclamation-triangle',
      lbl: 'Vencidos',
      num: vencidos.count,
      sub: <>Monto en mora <b>{fmtMoney(vencidos.monto_en_mora)}</b></>,
    },
    {
      id: 'por_vencer',
      tone: 'warning',
      icon: 'pi-clock',
      lbl: 'Por vencer (30 dias)',
      num: porVencer.count,
      sub: <>Por cobrar <b>{fmtMoney(porVencer.monto)}</b></>,
    },
    {
      id: 'monto_mes',
      tone: 'info',
      icon: 'pi-calendar',
      lbl: 'Monto del mes',
      num: fmtMoney(k.monto_mes ?? 0),
      sub: <>Vencimientos pendientes este mes</>,
    },
    {
      id: 'clientes',
      tone: 'success',
      icon: 'pi-users',
      lbl: 'Clientes con vencimientos',
      num: k.clientes_con_vencimientos ?? 0,
      sub: <>Cartera activa en seguimiento</>,
    },
  ];

  return (
    <div className="venc-kpis">
      {cards.map((c) => (
        <button
          key={c.id}
          type="button"
          className={`venc-kpi tone-${c.tone} ${active === c.id ? 'selected' : ''}`}
          onClick={() => onPick(c.id)}
        >
          <span className="accent" />
          <div className="lbl"><i className={`pi ${c.icon}`} />{c.lbl}</div>
          <div className="num">{c.num}</div>
          <div className="sub">{c.sub}</div>
        </button>
      ))}
    </div>
  );
}
